var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-item-image"},[(this.src)?_c('img',{attrs:{"src":this.url}}):_vm._e(),(_vm.desc)?_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }